import { createStore } from 'satcheljs';
import { type ThemeId } from '../schema/ThemeId';
import { ThemeMode } from '../schema/ThemeMode';
import type ThemeStore from '../schema/ThemeStore';

const INIT_STORE: ThemeStore = {
    themeId: 'Blue',
    themeMode: ThemeMode.Light,
    isDarkTheme: false,
    customPalette: {},
};

export const store = createStore<ThemeStore>('miniThemeStore', INIT_STORE)();
